<i18n src='@/locale/current-stationary-localization.json'></i18n>
<i18n src='@/locale/person-localization.json'></i18n>

<template>
    <v-container >
        <v-data-table
            dense
            :headers="headers"
            :options.sync="options"
            :items="gridData"
            :server-items-length="gridDataTotalCount"
            class="elevation-1 row-pointer"
            :footer-props="footerProps"
            @click:row="$emit('clickedOnRow',$event)"
        >
            <template v-slot:header.FatherNameAndGender="{ header }">
                <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    class="mt-1"
                    v-model="patientFilter.FatherName"
                    @change="OnSearch"
                    :label="$t('Fathers_Name')"
                ></v-text-field>
            </template>
            <template v-slot:item.DateOfBirth="{ item }">
                {{ FormatDate(item.DateOfBirth) }}
            </template>
            <template v-slot:item.HistoryDateFrom="{ item }">
                {{ FormatDate(item.HistoryDateFrom) }}
            </template>
            <template v-slot:no-data>
                <v-btn color="primary my-2" depressed @click="ReloadGrid">{{
                        $t('Refresh')
                    }}</v-btn>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import VWmCreateEditDialog from '@/component/nosology/create-edit-dialog.vue';
import currentStationaryService from "@/service/current-stationary-service";
import {getDateStr} from '@/script/common';

export default {
    components: {
        VWmCreateEditDialog,
    },
    created() {
        this.ReloadGrid()
    },
    data() {
        return {
            footerProps: {
                itemsPerPageOptions: [10, 25, 50, 100],
                showFirstLastPage: true,
                firstIcon: 'first_page',
                lastIcon: 'last_page',
                prevIcon: 'navigate_before',
                nextIcon: 'navigate_next',
            },
            patientFilter: {
                PersonalNumber: null,
                FirstName: null,
                LastName: null,
                FatherName: null
            },
            historyFilter: {
                HistoryNumber: null,
                HistoryType: null
            },
            diagnosisFilter: {
                dateFrom: null,
                dateTill: null,
                number: null,
            },
            headers: [
                {
                    text: this.$t('Personal_Num'),
                    value: 'PidAndPhone',
                    sortable: false,
                },
                { text: this.$t('History_Num'), value: 'HistoryNumber', sortable: false },
                { text: 'N', value: 'DiagnosisNumber', sortable: false },
                { text: this.$t('Last_Name'), value: 'LastName', sortable: false },
                { text: this.$t('Name'), value: 'FirstName', sortable: false },
                {
                    text: this.$t('Fathers_Name'),
                    value: 'FatherNameAndGender',
                    sortable: false,
                    align: 'start',
                },
                { text: this.$t('Birth_Date'), value: 'DateOfBirth', sortable: false },
                { text: this.$t('Age'), value: 'Age', sortable: false },
                { text: this.$t('Address'), value: 'Address', sortable: false },
                { text: this.$t('History_Date_From'), value: 'HistoryDateFrom', sortable: false },
                { text: this.$t('Laying_Days_Shortened'), value: 'LayingDays', sortable: false },
                { text: this.$t('History_Date_Till'), value: 'HistoryDateTillOrDoctorLastName', sortable: false },
            ],
            gridData: [],
            gridDataTotalCount: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
            },
            lastSearch: null,
        };
    },

    computed: {
        filter() {
            let clearNullKey = function (items) {
                let keys = Object.keys(items);
                for (let i = 0; i < keys.length; i++) {
                    if (items[keys[i]] === null) {
                        delete items[keys[i]];
                    }
                }
            };
            let onlyNonemptyKeys = function (items) {
                clearNullKey(items);
                if (Object.keys(items).length === 0) {
                    return null;
                }
                return items;
            };
            let patientFilter = onlyNonemptyKeys({ ...this.patientFilter });
            let historyFilter = onlyNonemptyKeys({ ...this.historyFilter });
            let diagnosisFilter = onlyNonemptyKeys({ ...this.diagnosisFilter });
            let result = {
                PatientFilter: patientFilter,
                HistoryFilter: historyFilter,
                DiagnosisDateFrom: diagnosisFilter == null ? null : diagnosisFilter.dateFrom,
                DiagnosisDateTill: diagnosisFilter == null ? null : diagnosisFilter.dateTill,
                DiagnosisNumber: diagnosisFilter == null ? null : diagnosisFilter.number
            };
            clearNullKey(result);
            return result;
        }
    },

    watch: {
        'options.page'() {
            this.ReloadGrid();
        },
        'options.itemsPerPage'() {
            this.ReloadGrid();
        }
    },

    methods: {
        OnSearch() {
            // if (this.lastSearch !== this.filter.search) {
            if (this.options.page === 1) {
                this.ReloadGrid();
            } else {
                this.options.page = 1;
            }
            // }
        },
        ReloadGrid() {
            const { sortBy, sortDesc, page, itemsPerPage } = this.options;
            // this.lastSearch = this.filter;
            currentStationaryService
                .getData(page, itemsPerPage, this.filter)
                .then((data) => {
                    this.gridData = data.data;
                    // შესაცვლელია data.total-ით
                    this.gridDataTotalCount = data.data.length;
                });
        },
        FormatDate(date) {
            return getDateStr(date, { withoutTimezone: true });
        },
        setPatientSearchFieldData(searchText, historyType) {
            let searchValue =  searchText.trim().replace(/ {2,}/g, " ");
            let isPersonalNumber = /^\d{11}$/.test(searchValue);
            let isHistoryNumber = !isPersonalNumber && /\d/.test(searchValue);

            // Clear search data fields
            this.historyFilter.HistoryType = null;
            this.patientFilter.PersonalNumber = null;
            this.historyFilter.HistoryNumber = null;
            this.patientFilter.LastName = null;
            this.patientFilter.FirstName = null;
            this.patientFilter.FatherName = null;

            // Set search data fields with new values
            if (historyType !== null && historyType >= 0 && historyType <= 2) {
                this.historyFilter.HistoryType = historyType;
            }
            if (searchValue) {
                if (isPersonalNumber) {
                    this.patientFilter.PersonalNumber = searchValue;
                } else if (isHistoryNumber) {
                    this.historyFilter.HistoryNumber = searchValue;
                } else {
                    let names = searchValue.split(" ");
                    if (names.length > 0) {
                        this.patientFilter.LastName = names[0];
                    }
                    if (names.length > 1) {
                        this.patientFilter.FirstName = names[1];
                    }
                    if (names.length > 2) {
                        this.patientFilter.FatherName = names[2];
                    }
                }
            }

            this.OnSearch();
        }
    },
};
</script>

<style>
.row-pointer > .v-data-table__wrapper > table > tbody > tr:hover {
    cursor: pointer;
}
</style>
